import ManageFaqDrawer from './ManageFaqDrawer.component';

export default ManageFaqDrawer;